module.exports = __webpack_public_path__ + "static/media/cricket-banner.d9ef434d.png";